import { render, staticRenderFns } from "./HomeAvatar.vue?vue&type=template&id=1155c097&scoped=true&lang=pug"
import script from "./HomeAvatar.vue?vue&type=script&lang=js"
export * from "./HomeAvatar.vue?vue&type=script&lang=js"
import style0 from "./HomeAvatar.vue?vue&type=style&index=0&id=1155c097&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155c097",
  null
  
)

export default component.exports